import { apiRequest } from './client.js';

/**
 * Disbursement artifacts (ADR-0009 D8, link-only v1). Currently used by the
 * loan-migration form to inline-create the `loan_consent` evidence record from
 * a Drive URL before submitting the migration itself.
 */

export interface ArtifactResponse {
  id: string;
  kind: string;
  fileUrl: string;
  fileName: string;
  fileSha256: string;
  fileSizeBytes: number;
  mimeType: string;
  uploadedAt: string;
  notes: string | null;
}

/**
 * Create a `loan_consent` artifact from a Drive URL. The backend's link-only v1
 * fills fileSha256/fileSizeBytes/mimeType with sentinels server-side, so only
 * the URL + filename (+ optional notes) are sent. `kind` is hardcoded — this
 * helper is loan-consent-specific (future use cases can generalise).
 */
export function createLoanConsentArtifact(args: {
  fileUrl: string;
  fileName: string;
  notes?: string;
}): Promise<ArtifactResponse> {
  return apiRequest<ArtifactResponse>('/v1/disbursement-artifacts', {
    method: 'POST',
    body: { kind: 'loan_consent', fileUrl: args.fileUrl, fileName: args.fileName, ...(args.notes ? { notes: args.notes } : {}) },
  });
}
